import { call, put, select } from 'redux-saga/effects';
import { addItemRequest, getItemsRequest, updateItemRequest } from '../../spItems/api';
import { VPORequirementsConditionsListName } from 'src/api/config';
import { getActionData, getActionDataSuccess } from '../actions';
import { getDefaultSaga } from './getDefaultSaga';
import { updateDefaultSaga } from 'src/modules/spItems/sagas/updateDefaultSaga';
import { addDefaultSaga } from 'src/modules/spItems/sagas/addDefaultSaga';
import { actionsVPO, VPOInconsistences } from 'src/pages/DashboardPage/vpo/api/vpo.config';
import { myTaskActionsListName } from 'src/api/config/myTasksActions.config';

export function* getActionDataSaga({ payload }: any): Generator<any, void, unknown> {
  try {
    if (payload) {
      const { columnID, departmentID, departmentTitle, groupID, groupRequirementID, processID, requirementID, factoryID } = payload;

      console.log('payload', payload);

      const actionsResponse: unknown = yield call<any>(getDefaultSaga, {
        listName: actionsVPO,
        filters: {
          Subdivision: departmentID,
          DemandVPOColumns: requirementID,
          FactoryID: '' + factoryID
        },
      });

      console.log('actionsResponse', actionsResponse);

      let inconsistencesResponse: any = {
        items: []
      },
      planListResponse: any = {
        items: []
      }

      if((actionsResponse as any)?.items && (actionsResponse as any)?.items.length > 0){
        inconsistencesResponse = yield call<any>(getDefaultSaga, {
          listName: VPOInconsistences,
          filters: { IdVPOactions: (actionsResponse as any)?.items[0]?.ID },
        });

        const descriptionValues = inconsistencesResponse?.items.map((item: any) => `*#VPO_${item.ID}`);

        if(descriptionValues && descriptionValues.length > 0){
          //! Разбивка массива на части по 20 элементов для избежания слишком длинных URL
          const chunkSize = 20;
          const allItems: any[] = [];

          for (let i = 0; i < descriptionValues.length; i += chunkSize) {
            const chunk = descriptionValues.slice(i, i + chunkSize);
            const chunkResponse: any = yield call<any>(getDefaultSaga, {
              listName: myTaskActionsListName,
              filters: { ImportantHashTag: chunk },
            });

            if (chunkResponse?.items) {
              allItems.push(...chunkResponse.items);
            }
          }

          planListResponse = { items: allItems };
        }
      }

      yield put(
        getActionDataSuccess({
          formAction: (actionsResponse as any).items[0],
          inconsistences: inconsistencesResponse.items,
          actions: planListResponse.items,
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
